import { IconType } from "react-icons";


export interface HeaderConfig {
   'Content-type': string,
   authorization?: string
}

export interface ILogin {
   email: string,
   password: string
}

export interface ISession {
   email?: string;
   accessToken: string
}
export interface IUserData {
   email: string;
   emp_id?: string;
   username?: string,
   location: string,
   password_expire: number,
   id: number,
   fname: string,
   lname: string,
   phone: string,
   position: number,
   department: number,
   busy: number,
   region: string,
   department_detail: IUserDepartment
   position_detail: IUserPosition

}

export interface IUserDepartment {
   id: number,
   code: string,
   description: string,
   region: string,
   admin: number
}
export interface IUserPosition {
   id: number,
   value: string,
   actions: string
}

export interface IMenuItem {
   id: number,
   text: string,
   icon: string | IconType,
   clicked?: boolean
}

export interface IPaginationOptions {
   page?: number,
   take?: number,
   paginate?: boolean,
}
export type User = {
   id: number,
   emp_id?:string,
   username?: string,
   fname: string,
   lname: string,
   email: string,
   phone?: string,
   location?: string,
   position: number,
   department: number,
   dept_code?: string,
   busy: number,
   region: string,
   position_detail?: IUserPosition,
   department_detail?: IUserDepartment,

}
export type IUser = {
   id?: number,
   username?: string,
   emp_id?: string,
   fname: string,
   lname: string,
   email: string,
   phone?: string,
   location?: string,
   position?: number,
   department: number,
   busy: number,
   password?: string
}

export type Vehicle = {
   id: number,
   pnumber: string,
   chassis_no: string,
   location: string,
   brand: string,
   model: string,
   year: number,
   mileage: number,
   current_mileage: number,
   last_refuel_mileage?: number,
   last_refuel_date?: number,
   last_maintenance_mileage?: number,
   last_maintenance_date?: number,
   donor?: string,
   project?: string,
   fundcode?: string,
   a_cost?: string,
   a_date?: number,
   last_update?: number,
   in_use: number,
   last_location?: string,
   next_service_mileage: number,
   project_detail?: IProjectDetail
}
export enum VEHICLE_STATUS {
   "DISPOSED" = 3,
   "IN_USE" = 1,
   "AVAILABLE" = 0
}
export enum USER_STATUS {
   "DELETED" = 3,
   "BUSY" = 1,
   "AVAILABLE" = 0
}
export type Trip = {
   start_city: string,
   destination_city: string,
   status: string,
   start_location: string,
   start_mileage: number,
   end_mileage?: number,
   date_created: number,
   last_updated?: number,
   id: number,
   start_time?: string | number,
   end_time?: string | number,
   remark?: string,
   request_id: number,
   destination: string,
   driver: number,
   vehicle: string,
   vehicle_id: number,
   requestor: number,
   request: IVehicleRequest,
   fundcode: string,
   approver: number,
   driver_detail?: User,
   vehicle_detail?: Vehicle,
   nameOfDriver?: string,
   nameOfRequestor?: string,
   closer?: number,
}

export type Notification = {
   id: number,
   time_created: number,
   status: number,
   message: string,
   title: string,
   recipient: number,
   time_read: number,
   target: number,
   type: number
}

export type CustomTime = {
   h: number,
   m: number,
   s: number
}
export interface IVehicleRequest {
   id: number;
   requestor: number;
   type: number;
   destination: string;
   purpose: string;
   duration: null;
   start_time: number;
   end_time: number;
   project: string;
   fundcode: string;
   account: string;
   source: string;
   category: string;
   activity: string;
   status: number;
   remark: string;
   admin: number;
   remark1: string;
   approver: number;
   approved_by: number;
   attended_by: number;
   date_created: number;
   last_updated: number;
   vehicle: string;
   driver: number;
   vehicle_id: number;
   start_city: string;
   destination_city: string;
   start_location: string;
   closed_by: number;
   comment?: string;
   project_detail: IProjectDetail;
   statusText: string;
   nameOfApprover: string;
   nameOfDefaultApprover: string;
   nameOfCloser: string;
   nameOfDriver: string;
   nameOfAdmin: string;
   nameOfRequestor: string;
   nameOfAttender: string;
   amount?: number;
   price?: string;
   mileage?:number,
   requestor_detail?: User,
   admin_detail?: User,
   driver_detail?: User,
   default_approver?: User,
   approver_detail?: User,
   attender_detail?: User,
   closer_detail?: User
}

export interface IFuelRequest {
   id: number;
   requestor: number;
   type: number;
   vehicle: string;
   vehicle_id: number;
   driver?:number;
   mileage: number;
   a_mileage: number;
   supplier: number;
   price: string;
   project: string;
   fundcode: string;
   account: string;
   source: string;
   category: string;
   activity: string;
   status: number;
   approver: number;
   approved_by: number;
   start_time: number;
   date_processed: number;
   amount: number;
   a_amount: number;
   a_price: string;
   date_created: number;
   remark?: string;
   admin: number;
   remark1?: string;
   comment?: string;
   attended_by: number;
   closed_by: number;
   last_updated: number;
   supplier_name: string;
   project_detail?: IProjectDetail;
   vehicle_detail?: Vehicle;
   statusText: string;
   nameOfApprover: string;
   nameOfDefaultApprover: string;
   nameOfRequestor: string;
   nameOfCloser: string;
   nameOfAdmin: string;
   nameOfAttender: string;
   supplier_detail?: ISupplier;
   requestor_detail?: User,
   admin_detail?: User,
   default_approver?: User,
   approver_detail?: User,
   attender_detail?: User,
   closer_detail?: User
}
export interface IMaintenanceRequest {
   id: number;
   requestType?: number;
   requestor: number;
   type: number;
   driver?:number;
   vehicle: string;
   vehicle_id: number;
   mileage: number;
   a_mileage: number;
   supplier: number;
   project: string;
   fundcode: string;
   account: string;
   source: string;
   category: string;
   activity: string;
   status: number;
   approver: number;
   approved_by: number;
   start_time: number;
   date_processed: number;
   amount?: number;
   price?:string,
   a_cost: number;
   date_created: number;
   remark?: string;
   admin: number;
   remark1?: string;
   comment: string;
   attended_by: number;
   closed_by: number;
   last_updated: number;
   supplier_name: string;
   project_detail: IProjectDetail;
   statusText: string;
   nameOfApprover: string;
   nameOfDefaultApprover: string;
   nameOfRequestor: string;
   nameOfCloser: string;
   nameOfAdmin: string;
   nameOfAttender: string;
   supplier_detail: ISupplier; 
   cost: number;
   parts: string;
   description: string;
   startTime: string;
   location: string,
   cost_distribution?:string,
   distribution?:any,
   requestor_detail?: User,
   admin_detail?: User,
   default_approver?: User,
   approver_detail?: User,
   attender_detail?: User,
   closer_detail?: User
}
export interface ISupplier {
   id: number;
   name: string;
   service: string;
   tin?: string;
   region: string;
   status: string;
}
export type IProjectDetail = {
   id: number;
   name: string;
   code: string;
   start_date: number;
   end_date: number;
   donor: string;
   coordinator: number;
   nameOfCoordinator?:string;
   status: number;
   comment?: string;
   department: number;
   coordinator_detail?: User;
   department_detail?: IDepartmentDetail;
}

export interface IDepartmentDetail {
   id?: number;
   code: string;
   description: string;
   region: string;
   admin: number;
   admin_detail?: User
}

export type Fundcode = {
   id: number;
   project: string;
   project_id: number;
   code: string;
   expiration: number;
   activities: string [];
   project_detail?: IProjectDetail;
}

export interface ISummaryCard {
   title: string,
   value: string | number,
   name?: string,
   id?: string | number,
   bg?: string,
   color?: string
}

export interface IRequestStatusBadge {
   icon: IconType
   text: string,
   color: string
}

export enum RequestStatus {
   "PENDING" = 0,
   "APPROVED" = 1,
   "AUTHORIZED" = 2,
   "CLOSED" = 3,
   "REJECTED" = 4,
   "CANCELLED" = 5

}
export class ApiResponse {
   status!: number;
   statusText!: string;
   data: any
}
export interface      ISelectOption {
   label: string,
   value: string | number | null | { [key: string]: any }
}
